import { Box } from "@mui/material";
import React from "react";
import { EMAIL_ERROR } from "../../utils/constants";
import SnackBarHome from "../Snackbar/SnackbarHome";

const ResetPasswordStageOne = ({
  setForgotPasswordStage,
  user,
  userError,
  handleChange,
  handleForgotPassword,
  open,
  setOpen,
  message,
}) => {
  return (
    <>
      <h3 className="reset-title mb-4">Reset your password</h3>

      
      <div className="field-col full-width">
        <label className="field-title">Enter your email<span>*</span></label>
        <input className="field-input-login" name="verifyEmail" type="text" required value={user?.verifyEmail} onChange={handleChange} 
        onKeyDown={(e) => {
          if (e.key === 'Enter') {             
              handleForgotPassword(e);             
          }
        }}
        />
        <span className="error-message">{userError?.verifyEmailError ? EMAIL_ERROR : ""}</span>
      </div>


      <SnackBarHome
        open={open}
        setOpen={setOpen}
        severity="error"
        message={message}
         autoHideDuration={null}
      />
      
      <button className="btn primary-btn me-3 mb-3" onClick={(event) => {handleForgotPassword(event);}} disabled={!user?.verifyEmail} onKeyDown={(e) => {
                            if (e.key === ' ') { // Check if the pressed key is the spacebar
                                e.preventDefault(); // Prevent the default action (inserting a space)
                            }
                          }} >
        Send OTP
      </button>
      <button className="btn primary-border-btn mb-3" onClick={(event) => { setForgotPasswordStage(0); }} onKeyDown={(e) => {
                            if (e.key === ' ') { // Check if the pressed key is the spacebar
                                e.preventDefault(); // Prevent the default action (inserting a space)
                            }
                          }} >
        Back to Sign in
      </button>

      <div style={{ marginTop: "15px" }}>
        For any queries, please call{" "}
        <a href="tel:+918062281345">+91 80622 81345</a> or email{" "}
        <a href="mailto:support@carbn.ai">support@carbn.ai</a>.
      </div>
    </>
  );
};

export default ResetPasswordStageOne;
